module.exports = __webpack_public_path__ + "img/lock.7d0bc23a.svg";